import { PromptSubTypes, AnswerTypeEnum } from '../constants/enums';
import { isAiInterviewStrategy } from './testgroups';

/**
 * Determines if prompts are available for a given strategy and prompt subtype.
 *
 * @param {string} strategy - The strategy to check (e.g., AI interview strategy).
 * @param {string} promptSubType - The subtype of the prompt to evaluate.
 * @returns {boolean} Returns `true` if prompts are available for the given strategy and subtype, otherwise `false`.
 */
export const getAvailablePromptsByStrategy = (strategy, promptSubType) => {
  if (!isAiInterviewStrategy(strategy)) return true;
  return PromptSubTypes.CONCEPTS_CORRECTION === promptSubType;
};

/**
 * Returns the prompt sub-type based on the current type of question.
 *
 * @param {AnswerTypeEnum} currentTypeQuestion - The current type of question to evaluate.
 * @returns {PromptSubTypes|undefined} The corresponding prompt sub-type if the question type is TEXT_AI, otherwise undefined.
 */
export const getPromptSubTypeByCurrentTypeQuestion = (currentTypeQuestion) =>
  currentTypeQuestion === AnswerTypeEnum.TEXT_AI ? PromptSubTypes.CONCEPTS_CORRECTION : undefined;
